import Big from 'big.js';

export const getQuoteSpreadDisplay = (bid: string, offer: string): string => {
  const spread = Big(offer).minus(bid).div(Big(offer).add(bid).div(2)).times(100).toNumber();

  // If result > 1000 BPS, return as %
  return Math.abs(spread) < 10 ? (spread * 100).toFixed(2) : spread.toFixed(2) + '%';
};
